import { useState } from 'react';
import type { PnpCashierContent, TrustlyLimits } from '../pnpCashier.types';
import { sanitizeAmountInput, validateAmount } from '../pnpCashier.utils';

export const useDepositForm = (
  content: PnpCashierContent,
  limits: TrustlyLimits | null,
  currencySymbol: string,
) => {
  const [amount, setAmount] = useState('');
  const [error, setError] = useState<string | null>(null);

  const handleAmountChange = (rawValue: string, symbol: string) => {
    const stripped = rawValue.replace(symbol, '');
    const sanitized = sanitizeAmountInput(stripped);

    setAmount(sanitized);
    setError(null);
  };

  const handleSelectAmount = (value: number) => {
    setAmount(String(value));
    setError(null);
  };

  const validate = (): boolean => {
    const min = limits?.minAmount ?? 0;
    const max = limits?.maxAmount ?? Infinity;
    const validationError = validateAmount(
      amount, min, max, content, currencySymbol,
    );

    setError(validationError);

    return validationError === null;
  };

  return {
    amount,
    error,
    handleAmountChange,
    handleSelectAmount,
    validate,
  };
};
